import { DYNAMIC_SURVEY_QUESTION_REGISTRY } from '@unity/config';
import { SurveyJSProperties } from './types';

const licenseKey = 'MWJmYzZhMDUtMzI1My00NTMyLTg5YjktOTBjNWRkYjFlYjczOzE9MjAyNi0wNS0xNSwyPTIwMjYtMDUtMTUsND0yMDI2LTA1LTE1';

export function bootstrapSurveyJS(module: typeof import('survey-core')) {
  module.Serializer.addProperty('question', {
    name: SurveyJSProperties.UnityIsTemplateQuestion,
    type: 'boolean',
    category: 'general',
    default: false,
    visible: false,
  });

  module.Serializer.addProperty('boolean', {
    name: SurveyJSProperties.UnityIsGridQuestion,
    displayName: 'Show in grid',
    type: 'boolean',
    category: 'general',
    default: false,
    visible: true,
  });

  module.Serializer.addProperty('radiogroup', {
    name: SurveyJSProperties.UnityIsGridQuestion,
    displayName: 'Show in grid',
    type: 'boolean',
    category: 'general',
    default: false,
    visible: true,
  });

  module.Serializer.addProperty('checkbox', {
    name: SurveyJSProperties.UnityIsGridQuestion,
    displayName: 'Show in grid',
    type: 'boolean',
    category: 'general',
    default: false,
    visible: true,
  });

  module.Serializer.addProperty('text', {
    name: SurveyJSProperties.UnityIsGridQuestion,
    displayName: 'Show in grid',
    type: 'boolean',
    category: 'general',
    default: false,
    visible: true,
  });

  module.Serializer.addProperty('dropdown', {
    name: SurveyJSProperties.UnityIsGridQuestion,
    displayName: 'Show in grid',
    type: 'boolean',
    category: 'general',
    default: false,
    visible: true,
  });

  module.Serializer.addProperty('tagbox', {
    name: SurveyJSProperties.UnityIsGridQuestion,
    displayName: 'Show in grid',
    type: 'boolean',
    category: 'general',
    default: false,
    visible: true,
  });

  module.JsonObject.metaData.findProperty('file', 'storeDataAsText').defaultValue = false;
  module.JsonObject.metaData.findProperty('file', 'waitForUpload').defaultValue = true;

  module.setLicenseKey(licenseKey);
}

export async function bootstrapUnityQuestions(module: typeof import('survey-angular-ui')) {
  const componentRegistry = DYNAMIC_SURVEY_QUESTION_REGISTRY;
  for (const [questionName, promise] of Object.entries(componentRegistry)) {
    const t = await promise();
    const qtype = questionName + '-question';
    module.AngularComponentFactory.Instance.registerComponent(qtype, t);
  }
}
